import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-mic",
  templateUrl: "./med-icon-mic.component.html",
})
export class MedIconMicComponent extends SvgMixinComponent {}
